import {
	GET_SERVERE_STATUS,
	USERS,
	ACCEPT_INVITATION,
	GET_AVATAR_FILE_UPLOAD_URL,
	UPDATE_TWO_STEP_AUTH,
	UPDATE_STEALTH_MODE,
	RESEND_TWO_STEP_AUTH,
	REMOVE_PARTICIPANT,
	DELETE_USER_AVATAR,
	ADMIN_USERS,
	USER_PAYMENT_METHODS
} from '../../constants';
import fetch from '../../fetch';

function getServerStatus()
{
	return fetch(`${GET_SERVERE_STATUS}`);
}

function removeParticipant(roomId, userId)
{
	return fetch(REMOVE_PARTICIPANT(roomId), {
		method: 'DELETE',
		body: JSON.stringify({ userId })
	});
}

function getPaymentMethod()
{
	return fetch(USER_PAYMENT_METHODS);
}

function attachPaymentMethod({ paymentMethod, planId, authToken })
{
	return fetch(USER_PAYMENT_METHODS, {
		method: 'POST',
		body: JSON.stringify({ paymentMethod, planId, authToken })
	});
}

function deletePaymentMethod(paymentMethod)
{
	return fetch(USER_PAYMENT_METHODS, {
		method: 'DELETE',
		body: JSON.stringify({ paymentMethod })
	});
}

function updateUser(user)
{
	return fetch(`${USERS}`, {
		method: 'POST',
		body: JSON.stringify(user)
	});
}

function getUserById(id)
{
	return fetch(`${ADMIN_USERS}/${id}`);
}

function updateUserById(id, user)
{
	return fetch(`${ADMIN_USERS}/${id}`, {
		method: 'PUT',
		body: JSON.stringify(user)
	});
}

function acceptInvitation(invitationToken, passcode)
{
	return fetch(`${ACCEPT_INVITATION}`, {
		method: 'POST',
		body: JSON.stringify({ invitationToken, passcode })
	});
}

function getUploadUrl(id, name)
{
	return fetch(GET_AVATAR_FILE_UPLOAD_URL(id), {
		method: 'POST',
		body: JSON.stringify({ name })
	});
}

function fetchAccount()
{
	return fetch(USERS);
}

function updateTwoStepAuth(twoStepAuth)
{
	return fetch(UPDATE_TWO_STEP_AUTH, {
		method: 'POST',
		body: JSON.stringify({ twoStepAuth })
	});
}

function updateStealthMode(stealth)
{
	return fetch(UPDATE_STEALTH_MODE, {
		method: 'POST',
		body: JSON.stringify({ stealth })
	});
}

function resendTwoStepAuth()
{
	return fetch(RESEND_TWO_STEP_AUTH, { method: 'POST' });
}

function deleteAvatar()
{
	return fetch(DELETE_USER_AVATAR, { method: 'DELETE' });
}

export {
	updateUser,
	getUserById,
	updateUserById,
	getServerStatus,
	acceptInvitation,
	fetchAccount,
	getUploadUrl,
	updateTwoStepAuth,
	resendTwoStepAuth,
	removeParticipant,
	deleteAvatar,
	updateStealthMode,
	getPaymentMethod,
	attachPaymentMethod,
	deletePaymentMethod
};
